import React from 'react';
import './App.css';
import Header from './components/Header';
import LogEntryForm from './components/LogEntryForm';
import ConsumptionLog from './components/ConsumptionLog';
import HarmReduction from './components/HarmReduction';
import { ConsumptionProvider } from './hooks/useConsumptionLog';
import { DrugsProvider } from './contexts/DrugsContext';

function App() {
  return (
    <DrugsProvider>
      <ConsumptionProvider>
        <AppContent />
      </ConsumptionProvider>
    </DrugsProvider>
  );
}

const AppContent: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header 
        title="BuzzKeeperApp"
        subtitle="Log your consumption and track your progress"
        className="mx-auto w-full max-w-lg flex flex-col justify-center items-center p-4 bg-gray-800 shadow-lg rounded-lg"
      />
      
      <main className="container mx-auto px-4 py-6 max-w-3xl">
        <LogEntryForm />
        <ConsumptionLog />
        <HarmReduction />
      </main>
      
      <footer className="container mx-auto px-4 py-4 border-t border-gray-800 text-center text-xs text-gray-500">
        <p>This app does not store any data beyond your current browser session.</p>            
        <p>Always practice harm reduction.</p>
        <p className="text-center">
          <a 
            href="https://x.com/BuzzKeeperApp" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-purple-500 hover:text-purple-400 transition-colors"
          >
            BuzzKeeperApp
          </a>
        </p>
        <p className="text-center mt-2">
          <a
            href="https://ko-fi.com/buzzkeeperapp"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white text-xs rounded-md transition-colors"
          >
            <img 
              src="https://storage.ko-fi.com/cdn/cup-border.png" 
              alt="Ko-fi cup" 
              className="h-3 w-auto mr-1"
            />
            Support on Ko-fi
          </a>
        </p>
      </footer>
    </div>
  );
};

export default App;
